"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Do not edit this file, it is automatically generated by @paprika/build-translations
var locales = {
    "fr": {
        "translation": {
            "left_navigation": {
                "loading": "Chargement",
                "hidden_target": "Impossible d'afficher votre sélection à cause de votre(vos) filtre(s) appliqué(s). Pour afficher l'élément, retirez le(s) filtre(s) approprié(s).",
                "sidenav_open": "Ouvrir la navigation",
                "sidenav_close": "Fermer la navigation",
                "expand": "Développer",
                "collapse": "Réduire",
                "small_search": "Saisissez au moins 2 caractères à rechercher.",
                "no_search_results": "Aucun résultat de recherche.",
                "filter_search": "Filtre...",
                "collection_archive": "Archive de collection",
                "activities": {
                    "title": "Activité",
                    "details": "Détails",
                    "reset": "Réinitialiser",
                    "load_more": "Charger plus",
                    "no_results": "Il n'y a aucune activité pour le filtre spécifié.",
                    "no_more_results": "Vous avez atteint la fin des activités pour le filtre spécifié.",
                    "actions": {
                        "created": "Créé(e)",
                        "deleted": "Supprimé(e)",
                        "updated": "Mis(e) à jour"
                    }
                },
                "settings": {
                    "title": "Paramètres"
                }
            }
        }
    }
};
exports.default = locales;
//# sourceMappingURL=fr.js.map